import { isHotkeyToOpenWidget } from '@uw/common-components';
import { useCallback, useEffect } from 'preact/hooks';
import { useApplicationSetup } from 'contexts/use-application-setup';
import { copyTextToClipboard } from '@uw/utils';
import { stateStore } from '../global/state.store';
import { Trigger } from '../types/trigger';

export const useKeyboardEvents = (config: ReturnType<typeof useApplicationSetup>) => {
  const keyDown = useCallback(
    (event) => {
      // CTRL + L
      if (event.keyCode === 76 && event.ctrlKey) {
        event.preventDefault();
        if (config.trigger === Trigger.Main && config.isWidgetReady) {
          stateStore.state.next('main.login');
        }
      }

      // CTRL + U - default; or Escape if focus is not inside a tooltip container
      if (
        isHotkeyToOpenWidget(config, event) ||
        (event.keyCode === 27 && !document.activeElement?.closest('.uwaw-main-tooltip-container'))
      ) {
        event.preventDefault();
        config.close();
      }

      // CTRL + K
      if (event.keyCode === 75 && event.ctrlKey) {
        event.preventDefault();
        const configCode = config.code;
        copyTextToClipboard(configCode);
      }

      // CTRL + J
      if (event.keyCode === 74 && event.ctrlKey) {
        event.preventDefault();
        const configUserId = config.config.current.services.userId;
        configUserId && copyTextToClipboard(configUserId);
      }
    },
    [config],
  );

  useEffect(() => {
    if (config.isOpen) {
      window.addEventListener('keydown', keyDown);
    }

    return () => {
      window.removeEventListener('keydown', keyDown);
    };
  }, [keyDown, config?.isOpen]);
};
